<template lang="pug">
	
	.political-intro

		section-intro(img="assets/images/political-joey.jpg" :title="translate('political.title')")

		splited-text(ref="splitedText" :text="text")

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scrollable from '~abstracts/scrollable'
	import SectionIntro from '~components/section-intro.vue'
	import SplitedText from '~components/splited-text.vue'
	
  	@Component({
		name: 'PoliticalIntro',
		components: { SectionIntro,SplitedText },
		data : function () {
			return {
				text : ""
			}
		}
	})

	class PoliticalIntro extends Scrollable {

		created () {
			this.text = this.translate('political.meeting')
		}

		mounted () {
			super.mounted()

			

			this._dom()
		}

		init () {
			super.init()

			
		}

		initTimeline () {
			super.initTimeline()
			
			let fakeAnim = {value: 0}

			this.tl.fromTo(fakeAnim,1,{value: 0},{value:1, ease: Power0.easeNone},0)
			this.tl.add(()=>{
				if(this.scroller.direction == 1 || this.isResized == false) {
					this.$refs.splitedText.animateIn()
				} else {
					this.$refs.splitedText.animateOut()
				}
				this.isResized = true
			},  window.innerHeight * .7 / (this.bounds.height))
		}


		_dom () {
			
			this.$text = this.$el.querySelector('.text')
			this.$fakeText = this.$el.querySelector('.fake-text')

		}

		_intervals () {
			
			this.scroller.point('text.in'+this.uid,{
				position: this.bounds.top + window.innerHeight * .3,
				direction: 1,
				exec: (e)=>{
					if(e.direction == 1 ) {
						this.$refs.splitedText.animateIn()
					} else {
						this.$refs.splitedText.animateOut()
					}
				}
			})

		}

		raf (y) {
			super.raf(y)	
		}

		_bind () {
			super._bind()
		}


		_resize () {
			super._resize()

			this.boundsAnim = {
				top: this.bounds.top - window.innerHeight,
				bottom: this.bounds.top + this.bounds.height
			}

			this.isResized = false

			this.initTimeline()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
		}

	}

	export default PoliticalIntro

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.political-intro
		width 100%
		// padding-top calc(50vh + 225px)
		position relative
		// min-height 100vh

		+break(xs)
			padding-left 30px
			padding-right 30px

		.title
			width 100%
			padding 0 10vw
			text-align center
			position relative
			z-index 80
			// top 50vh
			// opacity 0

			h2
				color #fff
				font-size 100px
				font-weight 700
				// transform scale(1.2)

				span
					display inline-block
					
					&.space
						width 20px

		.fixed-image-wrapper
			position absolute
			height 100vh
			width 100vw
			top 0
			left 0

			.image-mask
				position absolute
				width 980px
				height 550px
				top 50%
				left 50%
				z-index 60
				overflow hidden
				transform translate3d(-50%,-50%,0)

				.wrap-image
					position absolute
					top 50%
					left 50%
					transform translate3d(-50%,-50%,0)

				img
					width 100%
					height 100%
					object-fit cover
					transform scale(1.1)

		.splited-text
			width 50vw
			margin auto
			text-align center
			margin-top 30px
			max-width 720px
			position relative
			z-index 80

			+break(minlg)
				max-width 1000px

			+break(xs)
				width 100%

</style>


// WEBPACK FOOTER //
// political-intro.vue?35ddcac9